import { secondaryColors, StatusTagEnum, Tag } from '@tryhackme/thm-ui-components';
import styled from 'styled-components';

export const StyledTagTitle = styled.span`
  font-size: 1.4rem;
  line-height: 1.6rem;
`;

export const StyledTagWrapper = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
`;

export const StyledTag = styled(Tag)<{ status: StatusTagEnum }>`
  min-height: 3rem;
  color: ${secondaryColors.grey[100]};
  background: ${({ status }) => (status === StatusTagEnum.GREEN ? '#224633' : '#493042')};
`;

export const StyledMachineWrapper = styled.div`
  display: flex;
  padding: 2.4rem;
  justify-content: space-between;
  align-items: center;
  background: ${({ theme }) => theme.colors.secondary.main};
  border-radius: 5px;
  flex-wrap: wrap;
  gap: 1.6rem;
`;

export const StyledMachineDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  width: 100%;
  min-width: 15rem;
  flex: 999;
`;

export const StyledTitle = styled.span<{ $isWide: boolean }>`
  font-weight: ${({ theme }) => theme.fonts.weight.bolder};
  font-size: ${({ $isWide }) => ($isWide ? '2.4rem' : '1.8rem')};
  line-height: ${({ $isWide }) => ($isWide ? '3rem' : '2.3rem')};
  margin-right: 1rem;
  color: ${secondaryColors.grey[100]};
  vertical-align: middle;
`;

export const StyledImage = styled.img`
  vertical-align: middle;
`;

export const StyledAttackBoxButtonWrapper = styled.div`
  flex-grow: 1;
  & button:first-of-type,
  [role='group'] {
    width: 100%;
  }
`;
